
import { Vue, Component, Prop, ModelSync } from "vue-property-decorator";
import { Control } from "@/oxygen/classes/lib/types";
import TextInput from "@/components/Reusable/CustomInputs/TextInput.vue";
import WPMediaInput from "@/components/Reusable/CustomInputs/MediaInput/WPMediaInput.vue";
import { MediaInputValue } from "@/types/media";

@Component({
  components: {
    WPMediaInput,
    TextInput
  }
})
export default class OxygenMediaInput extends Vue {
  @Prop()
  control!: Control;

  @ModelSync("value", "input")
  syncedValue?: MediaInputValue;
}
